module.exports = __webpack_public_path__ + "img/google.2740139d.png";